import { render, staticRenderFns } from "./ArchivedAccount.vue?vue&type=template&id=4bc30c46"
import script from "./ArchivedAccount.vue?vue&type=script&lang=js"
export * from "./ArchivedAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports